import type { FC } from 'react';

import { useRefinementList } from 'react-instantsearch';

export const VirtualRefinements: FC<{ attribute: string }> = ({ attribute }) => {
  useRefinementList({ attribute, limit: 100 });

  return null;
};
